import { FieldPath } from 'react-hook-form';
import { ContactFormValues } from './types';
import { ContactType } from 'constants/contacts';
import qs from 'qs';

type ContactFormSection = 'social' | 'engage' | 'phones' | 'emails' | 'custom-fields';
type AutoFocusableContactField = FieldPath<ContactFormValues>;

interface ContactFormParams {
    only?: ContactFormSection[];
    autoFocus?: AutoFocusableContactField;
    type?: ContactType;
}

const getContactFormQueryParams = (params: ContactFormParams) => qs.stringify(params);

export { getContactFormQueryParams };
export type { ContactFormParams, ContactFormSection };
